import { Component } from "@angular/core";

@Component({
    selector: "dummy-component",
    templateUrl: "./dummy.component.html",
    styleUrls: ["./dummy.component.scss"]
})
export class DummyComponent {}
